import * as React from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { TabsContentProps } from './types';

/* -------------------------------------------------------------------------- */
/*                               Tabs Content                                 */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/* Use this with a Tabs.js component to render the content of your tabs       */
/* 
  const tabsContent = [
    { tabId: 1, component: <GeneralTabContent /> }, //Example of Component in Profile GeneralInformationTabsContent
    { tabId: 2, component: <PasswordTabContent /> },
    {
      tabId: 3,
      component: <MapOptionsTabContent />,
    },
  ];
    
  Tabs is a list of the tabs you want to render
  Active Tab the current active tab
  SetActiveTab your function to toggle de active tab                               
                                                                              */
/* -------------------------------------------------------------------------- */

const TabsContent: React.FC<TabsContentProps> = ({ activeTab, tabsContent = [] }) => {
  return (
    <TabContent activeTab={activeTab}>
      {tabsContent.map((tabContent) => (
        <TabPane key={`tabContent${tabContent.tabId}`} tabId={tabContent.tabId}>
          {tabContent.component}
        </TabPane>
      ))}
    </TabContent>
  );
};

export default TabsContent;
